import React, { Component } from 'react'
import { UpdateData } from 'step-wizard/src/StepWizard'
import ConfigureCalling from 'configure-calling'
import Api from 'api'
import LoaderFull from 'loader-full'
import styles from './styles'
import { withStyles } from '@material-ui/core'
import { theme } from 'get-theme'
import { PassData, StepName } from './CompanySetup'
import { formatPhoneNumber } from 'phone-numbers'
import Typography from 'typography'
import { Teammate } from 'models'
import PDCOpenConnection from 'pdc-open-connection'
import { BusinessHoursType } from 'business-hours/src/helper'
import ProgressBar from 'progress-bar-mui'
import { getValue } from 'remote-config-value'

/***/
export interface CallHandlingData {
    hasChange: boolean
    numberType: string
    phoneNumber
    schedules
    onCallOptionGroups
    smsForwardUser
    numberTypeOption
}

interface Props {
    classes
    saveId: number | string
    update: (data: UpdateData) => void
    smallView: boolean
    passData: PassData
}

interface State {
    mainCompanyNumberVoipDidId: number
    phoneNumber: any
    companyExtensionRules: any
    loading: boolean
    callHandlingLoading: boolean
    callHandlingData: CallHandlingData
    gotoNextType: string
    isValid: boolean
    saving: boolean
    simulateSaveProgress: boolean
    saveProgress: number
}

class CallHandlingStep extends Component<Props, State> {
    CHRNotificationsSubscriptions = []
    mounted = false
    constructor (props) {
        super(props)
        const passData = this.props.passData[StepName.CallHandling]
        const callHandlingData = passData ? JSON.parse(JSON.stringify(passData)) : { hasChange: false }
        this.state = {
            mainCompanyNumberVoipDidId: null,
            phoneNumber: null,
            companyExtensionRules: null,
            loading: true,
            callHandlingLoading: false,
            callHandlingData,
            gotoNextType: null,
            isValid: false,
            saving: false,
            simulateSaveProgress: false,
            saveProgress: 0
        }
    }

    componentDidMount = async () => {
        await Promise.all([
            this.loadNumber(),
            this.getCompanyExtensionRules()
        ])
        this.setState({ loading: false })
        PDCOpenConnection.onAccount('configure_chr', this.onConfigureCHRChange)
        this.mounted = true
    }

    componentWillUnmount = () => (this.mounted = false)

    onConfigureCHRChange = (voipId, payload) => this.mounted && this.CHRNotificationsSubscriptions.forEach(subscription => subscription(payload))

    getSaveData = () => this.state.callHandlingData

    loadNumber = async () => {
        const mainCompanyNumberVoipDidId = await Api.getMainCompanyNumberVoipDidId()
        const phoneNumbers = this.props.passData.extraData.phoneNumbers
        const phoneNumber = phoneNumbers.find(phoneNumber => phoneNumber.isMainCompanyNumber()) || phoneNumbers[0]
        phoneNumber.type = 'Main company number'
        this.setState({ mainCompanyNumberVoipDidId, phoneNumber })
    }

    getCompanyExtensionRules = async () => {
        const companyExtension = this.props.passData.extraData.companyExtension
        if (!companyExtension.id) return
        const companyExtensionRules = await Api.getExtensionRules(companyExtension.id)
        this.setState({ companyExtensionRules })
    }

    componentDidUpdate = (prevProps: Props): void => {
        const hasSaveRequest = Boolean(this.props.saveId && prevProps.saveId !== this.props.saveId)
        if (hasSaveRequest) {
            const gotoNextType = (this.props.saveId as string).split('#')[1] === 'submit' ? 'submit' : 'save'
            this.setState({ gotoNextType })
        }
    }

    renderLoader = () => {
        const { classes } = this.props
        return (
            <div className={classes.loadingDiv}>
                <LoaderFull data-test-id='csw-spinner-icon' text='Please wait...' color={theme.palette.secondary.main} size='bigger'/>
            </div>
        )
    }

    updatePhoneNumber = (phoneNumber) => this.setState({ phoneNumber })

    updateNumberRules = newNumberData => {
        const phoneNumber = { ...this.state.phoneNumber }
        phoneNumber.call_rules.rule_groups = newNumberData.numberRulesGroups
        phoneNumber.sms_forwarding = newNumberData.smsForwarding
        this.setState({ phoneNumber })
    }

    updateCompanyExtensionRules = companyExtensionRules => this.setState({ companyExtensionRules })

    getSchedules = () => {
        // return [{"id":"108065;108071","items":[{"id":"3370887;3370903","days_before":0,"days_after":0,"start_date":0,"end_date":0,"start_hour":0,"start_minute":0,"end_hour":0,"end_minute":0,"day":"M","voip_destination_id":0,"rank":1,"use_once":false,"expiration_date":null,"holiday":null},{"id":"3370889;3370904","days_before":0,"days_after":0,"start_date":0,"end_date":0,"start_hour":0,"start_minute":0,"end_hour":0,"end_minute":0,"day":"T","voip_destination_id":0,"rank":2,"use_once":false,"expiration_date":null,"holiday":null},{"id":"3370891;3370905","days_before":0,"days_after":0,"start_date":0,"end_date":0,"start_hour":0,"start_minute":0,"end_hour":0,"end_minute":0,"day":"W","voip_destination_id":0,"rank":3,"use_once":false,"expiration_date":null,"holiday":null},{"id":"3370893;3370906","days_before":0,"days_after":0,"start_date":0,"end_date":0,"start_hour":0,"start_minute":0,"end_hour":0,"end_minute":0,"day":"Th","voip_destination_id":0,"rank":4,"use_once":false,"expiration_date":null,"holiday":null},{"id":"3370895;3370908","days_before":0,"days_after":0,"start_date":0,"end_date":0,"start_hour":0,"start_minute":0,"end_hour":0,"end_minute":0,"day":"F","voip_destination_id":0,"rank":5,"use_once":false,"expiration_date":null,"holiday":null},{"id":"3370897;3370910","days_before":0,"days_after":0,"start_date":0,"end_date":0,"start_hour":0,"start_minute":0,"end_hour":0,"end_minute":0,"day":"S","voip_destination_id":0,"rank":6,"use_once":false,"expiration_date":null,"holiday":null},{"id":"3370899;3370913","days_before":0,"days_after":0,"start_date":0,"end_date":0,"start_hour":0,"start_minute":0,"end_hour":0,"end_minute":0,"day":"Su","voip_destination_id":0,"rank":7,"use_once":false,"expiration_date":null,"holiday":null}],"status":"on","name":"open-hours"},{"id":"108063;108072","items":[{"id":"3370888;3370909","days_before":0,"days_after":0,"start_date":0,"end_date":0,"start_hour":1,"start_minute":0,"end_hour":1,"end_minute":0,"day":"M","voip_destination_id":0,"rank":1,"use_once":false,"expiration_date":null,"holiday":null},{"id":"3370890;3370911","days_before":0,"days_after":0,"start_date":0,"end_date":0,"start_hour":1,"start_minute":0,"end_hour":1,"end_minute":0,"day":"T","voip_destination_id":0,"rank":2,"use_once":false,"expiration_date":null,"holiday":null},{"id":"3370892;3370914","days_before":0,"days_after":0,"start_date":0,"end_date":0,"start_hour":1,"start_minute":0,"end_hour":1,"end_minute":0,"day":"W","voip_destination_id":0,"rank":3,"use_once":false,"expiration_date":null,"holiday":null},{"id":"3370894;3370915","days_before":0,"days_after":0,"start_date":0,"end_date":0,"start_hour":1,"start_minute":0,"end_hour":1,"end_minute":0,"day":"Th","voip_destination_id":0,"rank":4,"use_once":false,"expiration_date":null,"holiday":null},{"id":"3370896;3370916","days_before":0,"days_after":0,"start_date":0,"end_date":0,"start_hour":1,"start_minute":0,"end_hour":1,"end_minute":0,"day":"F","voip_destination_id":0,"rank":5,"use_once":false,"expiration_date":null,"holiday":null},{"id":"3370898;3370917","days_before":0,"days_after":0,"start_date":0,"end_date":0,"start_hour":1,"start_minute":0,"end_hour":1,"end_minute":0,"day":"S","voip_destination_id":0,"rank":6,"use_once":false,"expiration_date":null,"holiday":null},{"id":"3370900;3370907","days_before":0,"days_after":0,"start_date":0,"end_date":0,"start_hour":1,"start_minute":0,"end_hour":1,"end_minute":0,"day":"Su","voip_destination_id":0,"rank":7,"use_once":false,"expiration_date":null,"holiday":null}],"status":"off","name":"lunch-break"},{"id":"108064;108067;108070","items":[{"id":"3370886;3370902","days_before":0,"days_after":0,"start_date":1640937600,"end_date":1641023999,"start_hour":1,"start_minute":0,"end_hour":1,"end_minute":0,"day":"M","voip_destination_id":0,"rank":1,"use_once":false,"expiration_date":null,"holiday":{"id":13,"name":"New Years Eve"}}],"status":"off","name":"holidays"},{"id":"108066;108068;108069","items":[{"id":"3370885;3370901","days_before":0,"days_after":0,"start_date":1609401600,"end_date":1609488000,"start_hour":1,"start_minute":0,"end_hour":1,"end_minute":0,"day":"M","voip_destination_id":0,"rank":1,"use_once":true,"expiration_date":null,"name":"waph","holiday":null}],"status":"off","name":"custom-holidays"}]
        const businessHoursPassData = this.props.passData[StepName.BusinessHours]
        const schedules = []
        if (businessHoursPassData.holidaysSchedule.id) {
            // means that the schedules (company business hours) are created
            schedules.push(businessHoursPassData.holidaysSchedule)
            schedules.push(businessHoursPassData.lunchSchedule)
            schedules.push(businessHoursPassData.customHolidaysSchedule)
            schedules.push(businessHoursPassData.openHoursSchedule)
        }
        return schedules
    }

    setCallHandlingLoading = (callHandlingLoading: boolean): void => this.setState({ callHandlingLoading })

    setIsValid = isValid => {
        if (!isValid) this.setState({ isValid, gotoNextType: null })
    }

    onSaved = () => {
        this.setState({ saving: false })
        this.props.update({ completed: true, gotoNext: true, saveData: this.getSaveData() })
    }

    renderConfigureCalling = (users: Teammate[]) => {
        const { smallView, passData } = this.props
        const editingData = { ...passData[StepName.CallHandling] }
        delete editingData.hasChange
        const setBusy = (hasChange: boolean): void => {
            const callHandlingData = { ...this.state.callHandlingData }
            callHandlingData.hasChange = hasChange
            this.setState({ callHandlingData }, () => {
                this.props.update({ completed: !hasChange, saveData: this.getSaveData() })
            })
        }
        const onUpdate = (data: CallHandlingData): void => {
            const callHandlingData = { ...this.state.callHandlingData }
            Object.assign(callHandlingData, data)
            this.setState({ callHandlingData }, () => {
                this.props.update({ completed: !data.hasChange, saveData: this.getSaveData() })
            })
        }
        const { companyExtension, companyName } = passData.extraData
        const schedules = this.getSchedules()
        const isSubmit = this.state.gotoNextType === 'submit'
        return (
            <ConfigureCalling
                mainCompanyNumberVoipDidId = {this.state.mainCompanyNumberVoipDidId}
                updateMainCompanyNumberVoipDidId = {mainCompanyNumberVoipDidId => this.setState({ mainCompanyNumberVoipDidId })}
                users = {users}
                companyExtension = {companyExtension}
                phoneNumber = {this.state.phoneNumber}
                updateNumberRules = {this.updateNumberRules}
                updatePhoneNumber = {this.updatePhoneNumber}
                companyName = {companyName}
                setBusy = {setBusy}
                schedules = {schedules}
                companyExtensionRules = {this.state.companyExtensionRules}
                updateCompanyExtensionRules = {this.updateCompanyExtensionRules}
                screenViewType = {{ isMobileView: smallView }}
                origin = 'company-setup'
                editingData = {editingData}
                setLoading = {this.setCallHandlingLoading}
                onUpdate = {onUpdate}
                save = {!!this.state.gotoNextType}
                savingMessage = {isSubmit ? getValue('company_setup_saving_message') : null}
                savingMessageDataTestId = 'csw-set-up-account-wait'
                setIsValid = {this.setIsValid}
                subscribeForCHRNotifications = {(subscription) => {
                    this.CHRNotificationsSubscriptions.splice(0, this.CHRNotificationsSubscriptions.length)
                    this.CHRNotificationsSubscriptions.push(subscription)
                }}
                onError = {() => { /* TODO: Handle this */ }}
                onSaved = {(hadChange = true) => {
                    if (!hadChange && isSubmit) return this.setState({ simulateSaveProgress: true, saveProgress: 0 })
                    this.onSaved()
                }}
                areBusinessHoursSet = {passData[StepName.BusinessHours].openHoursScheduleType === BusinessHoursType.OpenCustom}
            />
        )
    }

    renderSimulatedSaveProgress = () => {
        const { classes } = this.props
        if (!this.state.simulateSaveProgress) return null
        const { saveProgress } = this.state
        const savingMessage = getValue('company_setup_saving_message')
        if (saveProgress === 0) {
            this.setState({ saveProgress: 50 })
            setTimeout(() => {
                this.setState({ saveProgress: 100 })
                setTimeout(this.onSaved, 1100)
            }, 500)
        }
        return (
            <div className={classes.saveProgressContainer}>
                <div className='save-progress-wrapper'>
                    <Typography data-test-id='csw-set-up-account-wait' variant='body1'>{savingMessage}</Typography>
                    <ProgressBar
                        color = 'primary'
                        classes = {{ root: 'progress-bar-root', bar: 'progress-bar-fill' }}
                        value = {saveProgress}
                    />
                </div>
            </div>
        )
    }

    render = (): JSX.Element => {
        const { loading, saving } = this.state
        const { classes, smallView } = this.props
        const users = this.props.passData.extraData.users
        if (loading) return this.renderLoader()
        return (
            <div className={`${classes.callHandling} ${smallView ? 'mobile' : ''}`}>
                {this.state.callHandlingLoading || saving ? this.renderLoader() : null}
                <Typography variant='subtitle1' classes={{ root: 'phone-number-title' }}>{formatPhoneNumber(this.state.phoneNumber?.phone_number || '')}</Typography>
                {this.renderConfigureCalling(users)}
                {this.renderSimulatedSaveProgress()}
            </div>
        )
    }
}

export default withStyles(styles)(CallHandlingStep)
